import { IconProps } from "../../../types/style";

const LampFill = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.08375 9.33267H7.41709V9.46184C7.41709 10.3098 6.7275 10.9993 5.87959 10.9993H5.62167C4.77375 10.9993 4.08417 10.3098 4.08417 9.46184V9.33267H4.08375ZM9.50042 4.74934C9.50042 5.82851 9.03459 6.85559 8.22209 7.56726C7.91417 7.83726 7.69084 8.15601 7.55792 8.49934H3.90167C3.7525 8.13392 3.51584 7.79018 3.19542 7.49226C2.3 6.65851 1.87584 5.47976 2.03167 4.25851C2.24625 2.57518 3.62709 1.21476 5.31542 1.02393C6.385 0.903509 7.45292 1.24143 8.24792 1.95184C9.04375 2.66309 9.50042 3.68268 9.50042 4.74934ZM5.33375 5.16684C5.33375 5.39684 5.52 5.58351 5.75042 5.58351C5.98084 5.58351 6.16709 5.39684 6.16709 5.16684V3.08351C6.16709 2.85351 5.98084 2.66684 5.75042 2.66684C5.52 2.66684 5.33375 2.85351 5.33375 3.08351V5.16684ZM6.37542 6.62518C6.37542 6.28018 6.09542 6.00018 5.75042 6.00018C5.40542 6.00018 5.12542 6.28018 5.12542 6.62518C5.12542 6.97018 5.40542 7.25018 5.75042 7.25018C6.09542 7.25018 6.37542 6.97018 6.37542 6.62518Z"
          fill={color}
        />
      </svg>
    </div>
  );
};

export default LampFill;
